import { JSX } from "react/jsx-runtime";
import { DefaultSuggestionList } from "stream-chat-react";

export const SuggestionListWithHeader = (props) => {
  let header = "";
  let filteredValue = props.values || [];

  // TRIGGER: @ (Mentions)
  // Filter out users that don't have a name property
  // Users without names are incomplete profiles or system users
  if (props.currentTrigger === "@") {
    header = "";
    filteredValue = filteredValue.filter((user) => {
      // Check if user has a name property and it's not empty/whitespace
      return user && user.name && user.name.trim() !== "";
    });
  }

  // TRIGGER: / (Commands)
  // Disabled - return empty list
  if (props.currentTrigger === "/") {
    header = "";
    filteredValue = []; 
  }

  // TRIGGER: : (Emojis)
  // Use default emoji list from Stream
  if (props.currentTrigger === ":") {
    header = "";
  }

  // Prepare props with filtered values
  const newProps = {
    ...props,
    values: filteredValue,
  };

  return (
    <>
      <div className="suggestion-list__header">{header}</div>
      <DefaultSuggestionList {...newProps} />
    </>
  );
};